import listActions from 'src/modules/event/list/eventListActions';
import EventService from 'src/modules/event/eventService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'EVENT_DEMOTE';

const eventDemoteActions = {
  DEMOTE_STARTED: `${prefix}_DEMOTE_STARTED`,
  DEMOTE_SUCCESS: `${prefix}_DEMOTE_SUCCESS`,
  DEMOTE_ERROR: `${prefix}_DEMOTE_ERROR`,

  DEMOTE_ALL_STARTED: `${prefix}_DEMOTE_ALL_STARTED`,
  DEMOTE_ALL_SUCCESS: `${prefix}_DEMOTE_ALL_SUCCESS`,
  DEMOTE_ALL_ERROR: `${prefix}_DEMOTE_ALL_ERROR`,

  doDemoteAll: (ids, targetVisibility) => async (dispatch) => {
    try {
      dispatch({
        type: eventDemoteActions.DEMOTE_ALL_STARTED,
      });

      const result = await EventService.demoteAll(ids, targetVisibility);

      dispatch({
        type: eventDemoteActions.DEMOTE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.event.demoteAll.success', result.count),
      );

      getHistory().push('/event');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventDemoteActions.DEMOTE_ALL_ERROR,
      });
    }
  },
};

export default eventDemoteActions;
